import { Component } from '@angular/core';
import { Navigator } from "../../../components/menu/navigator";

@Component({
  selector: 'app-authenticator-change-success',
  templateUrl: './authenticator-change-success.component.html',
  styleUrls: ['./authenticator-change-success.component.scss'],
})
export class AuthenticatorChangeSuccessComponent {

  constructor(
    private navigator: Navigator
  ) { }

  close(){
    return this.navigator.dismissAll();
  }

  onBack() {
    this.navigator.navigateTo('ChangeAuthenticatorOptionComponent');
  }
}
